'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('SuggestSearchCtrl', ['$scope', '$log', 'ajaxSearch', function ($scope, $log, ajaxSearch) {
    $scope.searchUrl = '';
    $scope.sdquery = '';
    $scope.searchresults = [];
    $scope.total = 0;
    $scope.search_url = '';
    $scope.templates = {
        title_description: 'search/title_description.html',
        img_title: 'search/img_title.html',
        img_title_description: 'search/img_title_description.html',
        module_gallery: 'search/module_gallery.html',
        module_youtubegallery: 'search/module_youtubegallery.html',
    };
    $scope.str_len = 100;

    $scope.find = function () {
        if ($scope.searchUrl !== '') {
            ajaxSearch.search($scope.searchUrl, {sdquery: $scope.sdquery}).then(function (results) {
                if ($scope.sdquery === '') {
                    $scope.clear();
                } else {
                    $scope.displaySuggestions(results);
                    $scope.total = results.total;
                    $scope.search_url = results.search_url;

                }
            }, function (response) {
                $log.error(response);
            });
        }
    };
    $scope.displaySuggestions = function (results) {
        $scope.searchresults = results.data;
    };
    $scope.clear = function () {
        $scope.sdquery = '';
        $scope.total = 0;
        $scope.displaySuggestions([]);
    };
    $scope.getDataTemplate = function (data) {
        if (data.module === 'gallery' || data.module === 'photoalbums') {
            data.display_options.template.id = 'module_gallery';
        }
        if (data.module === 'youtubegallery') {
            data.display_options.template.id = 'module_youtubegallery';
        }
        if (typeof (data.display_options.template.id) !== 'undefined' && typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
            return $scope.templates[data.display_options.template.id];
        }
        return $scope.templates.title_description;
    };
    $scope.changeLocationHash = function (data, name, varname) {
        var hash = '!' + name + data.display_options.vars[varname];
        location.hash = hash;
    };
}]).directive('suggestSearchContainer', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.searchUrl = '';
            if (attr.searchUrl !== '') {
                scope.searchUrl = attr.searchUrl;
            }
        }
    };
})  .directive('highlightMatch', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        scope: {
            highlightMatch: '<'
        },
        link: function(scope, el, attrs) {
            let lastText = '';

            function applyHighlight(query) {
                if (el.unhighlight) el.unhighlight();
                if (query && el.highlight) {
                    el.highlight(query);
                }
            }

            if (attrs.ngBind) {
                scope.$watch(
                    () => scope.$eval(attrs.ngBind),
                    (newText) => {
                        lastText = newText || '';
                        $timeout(() => applyHighlight(scope.highlightMatch));
                    }
                );
            }

            scope.$watch('highlightMatch', (newQuery) => {
                $timeout(() => applyHighlight(newQuery));
            });
        }
    };
}]);